"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "languagesImporterWebpack", {
  enumerable: true,
  get: function () {
    return _languagesImporterWebpack.default;
  }
});
Object.defineProperty(exports, "vueI18nBodyGenerator", {
  enumerable: true,
  get: function () {
    return _i18nConfigGenerator.default;
  }
});
Object.defineProperty(exports, "validationCopiesExtractor", {
  enumerable: true,
  get: function () {
    return _extractValidatationCopies.default;
  }
});
Object.defineProperty(exports, "swordVueLanguages", {
  enumerable: true,
  get: function () {
    return _swordVueLanguages.default;
  }
});

var _languagesImporterWebpack = _interopRequireDefault(require("./modules/languages-importer-webpack"));

var _i18nConfigGenerator = _interopRequireDefault(require("./modules/i18n-config-generator.js"));

var _extractValidatationCopies = _interopRequireDefault(require("./modules/extract-validatation-copies.js"));

var _swordVueLanguages = _interopRequireDefault(require("./sword-vue-languages.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }